// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modalOverlay__XX76Q {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Modal_modalContent__acEU0 {
  background: #222121;
  border-radius: 12px;
  width: 30%;
  position: relative;
}
.Modal_modalContent__acEU0 .Modal_close__nwA12 {
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
}
.Modal_modalContent__acEU0 .Modal_close__nwA12 svg {
  fill: #BBB5AA;
}
.Modal_modalContent__acEU0 .Modal_back__o4LBH {
  position: absolute;
  left: 16px;
  top: 16px;
}

@media (max-width: 1024px) {
  .Modal_modalContent__acEU0 {
    border-radius: 0;
    height: 100%;
    width: 100%;
    overflow: scroll;
    padding-top: 70px;
  }
  .Modal_modalContent__acEU0 .Modal_close__nwA12 {
    top: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/modal/Modal.module.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AADF;;AAIA;EACE,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AADF;AAGE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AADJ;AAGI;EACE,aCUS;ADXf;AAKE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAHJ;;AAOA;EACE;IACE,gBAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;EAJF;EAME;IACE,SAAA;EAJJ;AACF","sourcesContent":["@use \"assets/styles/global\" as *;\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: #222121;\n  border-radius: 12px;\n  width: 30%;\n  position: relative;\n\n  .close {\n    cursor: pointer;\n    position: absolute;\n    right: 16px;\n    top: 16px;\n\n    svg {\n      fill: $icon-chevron;\n    }\n  }\n\n  .back {\n    position: absolute;\n    left: 16px;\n    top: 16px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .modalContent {\n    border-radius: 0;\n    height: 100%;\n    width: 100%;\n    overflow: scroll;\n    padding-top: 70px;\n\n    .close {\n      top: 60px;\n    }\n  }\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #EAD40C;\n$icon-secondary: #7B756B;\n$icon-chevron: #BBB5AA;\n$icon-always-dark: #212329;\n$icon-primary-control: #292621;\n$icon-hover: #575249;\n$icon-pressed: #575249;\n$icon-white: #ffffff;\n$icon-notification: #FF3333;\n$icon-warning: #E2B603;\n$icon-deposit: #009E69;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #171716;\n$background-secondary: #292621;\n$background-snackbar: #000000;\n$background-input: #3E3C37;\n\n$control-primary: #F2F740;\n$control-hover: #F5F966;\n$control-pressed: #E6EB3D;\n$control-green: #009E69;\n$control-green-hover: #33B187;\n$control-green-pressed: #009664;\n$control-dark: #3E3C37;\n$control-dark-hover: #51504B;\n$control-dark-pressed: #3B3934;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n\n$text-title: #FAF9F8;\n$text-subtitle: #DAD6CE;\n$text-body: #C2BDB2;\n$text-link: #00D68F;\n$text-error: #FF3333;\n$text-warning: #E2B603;\n$text-white: #FFFFFF;\n$text-dark: #292621;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `Modal_modalOverlay__XX76Q`,
	"modalContent": `Modal_modalContent__acEU0`,
	"close": `Modal_close__nwA12`,
	"back": `Modal_back__o4LBH`
};
export default ___CSS_LOADER_EXPORT___;
